"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// N.B. Nothing to update at the time of writing
// export interface UpdateVenueFeatureRequestBodyContract {}
//# sourceMappingURL=venueFeatures.js.map